import { render, staticRenderFns } from "./CramStudentList.vue?vue&type=template&id=27ea3211&"
import script from "./CramStudentList.vue?vue&type=script&lang=ts&"
export * from "./CramStudentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports